import { useEffect, useState } from 'react';
import LoadingScreen from './components/LoadingScreen';
import Navigation from './components/Navigation';
import HeroSimulator from './components/HeroSimulator';
import VehicleGallery from './components/VehicleGallery';
import ManufacturerBanners from './components/ManufacturerBanners';
import LatestNews from './components/LatestNews';
import InstagramFeed from './components/InstagramFeed';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function HomePage() {
  const [isLoading, setIsLoading] = useState(true);
  const [selectedVehicle, setSelectedVehicle] = useState('ALPHARD40');

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2500);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen bg-black">
      <Navigation />
      <HeroSimulator selectedVehicle={selectedVehicle} />
      <VehicleGallery onVehicleSelect={setSelectedVehicle} />
      <ManufacturerBanners />
      <LatestNews />
      <InstagramFeed />
      <CTASection />
      <Footer />
    </div>
  );
}
